const currencies: {
	[cultureName: string]: {
		symbol: string,
		decimalSeparator: string,
		decimalPlaces: number,
		groupSeparator: string,
		isoCode: string
	}
} = {
	'aa-DJ': {
		symbol: 'Fdj',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'DJF'
	},
	'aa-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'aa-ET': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ETB'
	},
	'af': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'AFN'
	},
	'af-NA': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NAD'
	},
	'af-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'agq-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'ak-GH': {
		symbol: 'GH₵',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GHS'
	},
	'am': {
		symbol: 'ብር',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AMD'
	},
	'am-ET': {
		symbol: 'ብር',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ETB'
	},
	'ar': {
		symbol: 'ر.س.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ARS'
	},
	'ar-001': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'ar-AE': {
		symbol: 'د.إ.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AED'
	},
	'ar-BH': {
		symbol: 'د.ب.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'BHD'
	},
	'ar-DJ': {
		symbol: 'Fdj',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'DJF'
	},
	'ar-DZ': {
		symbol: 'د.ج.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'DZD'
	},
	'ar-EG': {
		symbol: 'ج.م.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EGP'
	},
	'ar-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'ar-IL': {
		symbol: '₪',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ILS'
	},
	'ar-IQ': {
		symbol: 'د.ع.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'IQD'
	},
	'ar-JO': {
		symbol: 'د.ا.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'JOD'
	},
	'ar-KM': {
		symbol: 'CF',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'KMF'
	},
	'ar-KW': {
		symbol: 'د.ك.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'KWD'
	},
	'ar-LB': {
		symbol: 'ل.ل.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LBP'
	},
	'ar-LY': {
		symbol: 'د.ل.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'LYD'
	},
	'ar-MA': {
		symbol: 'د.م.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MAD'
	},
	'ar-MR': {
		symbol: 'أ.م.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MRU'
	},
	'ar-OM': {
		symbol: 'ر.ع.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'OMR'
	},
	'ar-PS': {
		symbol: '₪',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ILS'
	},
	'ar-QA': {
		symbol: 'ر.ق.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'QAR'
	},
	'ar-SA': {
		symbol: 'ر.س.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SAR'
	},
	'ar-SD': {
		symbol: 'ج.س.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SDG'
	},
	'ar-SO': {
		symbol: 'S',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'SOS'
	},
	'ar-SS': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SSP'
	},
	'ar-SY': {
		symbol: 'ل.س.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SYP'
	},
	'ar-TD': {
		symbol: 'FCFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XAF'
	},
	'ar-TN': {
		symbol: 'د.ت.‏',
		decimalSeparator: '.',
		decimalPlaces: 3,
		groupSeparator: ',',
		isoCode: 'TND'
	},
	'ar-YE': {
		symbol: 'ر.ي.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'YER'
	},
	'arn-CL': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CLP'
	},
	'as': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'as-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'asa-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'ast-ES': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'az': {
		symbol: '₼',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'AZN'
	},
	'az-Cyrl-AZ': {
		symbol: '₼',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'AZN'
	},
	'az-Latn-AZ': {
		symbol: '₼',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'AZN'
	},
	'ba': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BAM'
	},
	'ba-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'bas-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'be': {
		symbol: 'Br',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'be-BY': {
		symbol: 'Br',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BYN'
	},
	'bem-ZM': {
		symbol: 'K',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ZMW'
	},
	'bez-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'bg': {
		symbol: 'лв.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BGN'
	},
	'bg-BG': {
		symbol: 'лв.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BGN'
	},
	'bin-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'bm': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'BMD'
	},
	'bm-Latn-ML': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'bn': {
		symbol: '৳',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BND'
	},
	'bn-BD': {
		symbol: '৳',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BDT'
	},
	'bn-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'bo': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BOB'
	},
	'bo-CN': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CNY'
	},
	'bo-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'br': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BRL'
	},
	'br-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'brx-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'bs': {
		symbol: 'KM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BSD'
	},
	'bs-Cyrl-BA': {
		symbol: 'КМ',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BAM'
	},
	'bs-Latn-BA': {
		symbol: 'KM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BAM'
	},
	'byn-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'ca': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CAD'
	},
	'ca-AD': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ca-ES': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ca-ES-valencia': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ca-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ca-IT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ce-RU': {
		symbol: '₽',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'RUB'
	},
	'cgg-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'chr-Cher-US': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'co': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'COP'
	},
	'co-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'cs-CZ': {
		symbol: 'Kč',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CZK'
	},
	'cu': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CUP'
	},
	'cu-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'cy': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'cy-GB': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'da-DK': {
		symbol: 'kr.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'da-GL': {
		symbol: 'kr.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'dav-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'de': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'de-AT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'de-BE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'de-CH': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'de-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'de-IT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'de-LI': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'de-LU': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'dje-NE': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'dsb-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'dua-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'dv-MV': {
		symbol: 'ރ.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MVR'
	},
	'dyo-SN': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'dz': {
		symbol: 'Nu.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'DZD'
	},
	'dz-BT': {
		symbol: 'Nu.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BTN'
	},
	'ebu-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'ee': {
		symbol: 'GH₵',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'ee-GH': {
		symbol: 'GH₵',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GHS'
	},
	'ee-TG': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'el-CY': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'el-GR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-001': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'en-029': {
		symbol: 'EC$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-150': {
		symbol: 'XDR',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'XDR'
	},
	'en-AG': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-AI': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-AS': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-AT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-AU': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-BB': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BBD'
	},
	'en-BE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-BI': {
		symbol: 'FBu',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'BIF'
	},
	'en-BM': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BMD'
	},
	'en-BS': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BSD'
	},
	'en-BW': {
		symbol: 'P',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BWP'
	},
	'en-BZ': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BZD'
	},
	'en-CA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CAD'
	},
	'en-CC': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-CH': {
		symbol: 'CHF',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CHF'
	},
	'en-CK': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'en-CM': {
		symbol: 'FCFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XAF'
	},
	'en-CX': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-CY': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'en-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-DK': {
		symbol: 'kr.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'en-DM': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'en-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'en-FJ': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'FJD'
	},
	'en-FK': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'FKP'
	},
	'en-FM': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-GB': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'en-GD': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-GG': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'en-GH': {
		symbol: 'GH₵',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GHS'
	},
	'en-GI': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GIP'
	},
	'en-GM': {
		symbol: 'D',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GMD'
	},
	'en-GU': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-GY': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GYD'
	},
	'en-HK': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'HKD'
	},
	'en-ID': {
		symbol: 'Rp',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'IDR'
	},
	'en-IE': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'en-IL': {
		symbol: '₪',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ILS'
	},
	'en-IM': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'en-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'en-IO': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-JE': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'en-JM': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'JMD'
	},
	'en-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'en-KI': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-KN': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-KY': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KYD'
	},
	'en-LC': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-LR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LRD'
	},
	'en-LS': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ZAR'
	},
	'en-MG': {
		symbol: 'Ar',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'MGA'
	},
	'en-MH': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-MO': {
		symbol: 'MOP$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MOP'
	},
	'en-MP': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-MS': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-MT': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'en-MU': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MUR'
	},
	'en-MW': {
		symbol: 'MK',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MWK'
	},
	'en-MY': {
		symbol: 'RM',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MYR'
	},
	'en-NA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NAD'
	},
	'en-NF': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'en-NL': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-NR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-NU': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'en-NZ': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'en-PG': {
		symbol: 'K',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PGK'
	},
	'en-PH': {
		symbol: '₱',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PHP'
	},
	'en-PK': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PKR'
	},
	'en-PN': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'en-PR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-PW': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-RW': {
		symbol: 'RF',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'RWF'
	},
	'en-SB': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SBD'
	},
	'en-SC': {
		symbol: 'SR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SCR'
	},
	'en-SD': {
		symbol: 'SDG',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SDG'
	},
	'en-SE': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SEK'
	},
	'en-SG': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SGD'
	},
	'en-SH': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SHP'
	},
	'en-SI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'en-SL': {
		symbol: 'Le',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'SLL'
	},
	'en-SS': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SSP'
	},
	'en-SX': {
		symbol: 'NAf.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ANG'
	},
	'en-SZ': {
		symbol: 'E',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SZL'
	},
	'en-TC': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-TK': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'en-TO': {
		symbol: 'T$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TOP'
	},
	'en-TT': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TTD'
	},
	'en-TV': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'en-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'en-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'en-UM': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-US': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-VC': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'en-VG': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-VI': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'en-VU': {
		symbol: 'VT',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'VUV'
	},
	'en-WS': {
		symbol: 'WS$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'WST'
	},
	'en-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'en-ZM': {
		symbol: 'K',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ZMW'
	},
	'en-ZW': {
		symbol: 'US$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'eo-001': {
		symbol: 'XDR',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XDR'
	},
	'es': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'es-419': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'es-AR': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'ARS'
	},
	'es-BO': {
		symbol: 'Bs',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BOB'
	},
	'es-BR': {
		symbol: 'R$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BRL'
	},
	'es-BZ': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'BZD'
	},
	'es-CL': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'CLP'
	},
	'es-CO': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'COP'
	},
	'es-CR': {
		symbol: '₡',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CRC'
	},
	'es-CU': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CUP'
	},
	'es-DO': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'DOP'
	},
	'es-EC': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'USD'
	},
	'es-ES': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'es-GQ': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'es-GT': {
		symbol: 'Q',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GTQ'
	},
	'es-HN': {
		symbol: 'L',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'HNL'
	},
	'es-MX': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MXN'
	},
	'es-NI': {
		symbol: 'C$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NIO'
	},
	'es-PA': {
		symbol: 'B/.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PAB'
	},
	'es-PE': {
		symbol: 'S/',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PEN'
	},
	'es-PH': {
		symbol: '₱',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'PHP'
	},
	'es-PR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'es-PY': {
		symbol: '₲',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'PYG'
	},
	'es-SV': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'es-US': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'es-UY': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'UYU'
	},
	'es-VE': {
		symbol: 'Bs.S',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'VES'
	},
	'et': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ETB'
	},
	'et-EE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'eu-ES': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ewo-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fa-IR': {
		symbol: 'ريال',
		decimalSeparator: '/',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'IRR'
	},
	'ff-Latn-BF': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'ff-Latn-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'ff-Latn-GH': {
		symbol: 'GH₵',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'GHS'
	},
	'ff-Latn-GM': {
		symbol: 'D',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'GMD'
	},
	'ff-Latn-GN': {
		symbol: 'FG',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'GNF'
	},
	'ff-Latn-GW': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'ff-Latn-LR': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'LRD'
	},
	'ff-Latn-MR': {
		symbol: 'UM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MRU'
	},
	'ff-Latn-NE': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'ff-Latn-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'ff-Latn-SL': {
		symbol: 'Le',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'SLL'
	},
	'ff-Latn-SN': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fi': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fi-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fil-PH': {
		symbol: '₱',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PHP'
	},
	'fo': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'fo-DK': {
		symbol: 'kr.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'fo-FO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'fr': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-029': {
		symbol: 'EC$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XCD'
	},
	'fr-BE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'fr-BF': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-BI': {
		symbol: 'FBu',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'BIF'
	},
	'fr-BJ': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-BL': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-CA': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CAD'
	},
	'fr-CD': {
		symbol: 'FC',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CDF'
	},
	'fr-CF': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-CG': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-CH': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CHF'
	},
	'fr-CI': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-DJ': {
		symbol: 'Fdj',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'DJF'
	},
	'fr-DZ': {
		symbol: 'DA',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'DZD'
	},
	'fr-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-GA': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-GF': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-GN': {
		symbol: 'FG',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'GNF'
	},
	'fr-GP': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-GQ': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-HT': {
		symbol: 'G',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'HTG'
	},
	'fr-KM': {
		symbol: 'CF',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'KMF'
	},
	'fr-LU': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'fr-MA': {
		symbol: 'DH',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MAD'
	},
	'fr-MC': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-MF': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-MG': {
		symbol: 'Ar',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'MGA'
	},
	'fr-ML': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-MQ': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-MR': {
		symbol: 'UM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MRU'
	},
	'fr-MU': {
		symbol: 'Rs',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MUR'
	},
	'fr-NC': {
		symbol: 'FCFP',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XPF'
	},
	'fr-NE': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-PF': {
		symbol: 'FCFP',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XPF'
	},
	'fr-PM': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-RE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fr-RW': {
		symbol: 'RF',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'RWF'
	},
	'fr-SC': {
		symbol: 'SR',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SCR'
	},
	'fr-SN': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-SY': {
		symbol: 'LS',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'SYP'
	},
	'fr-TD': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'fr-TG': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'fr-TN': {
		symbol: 'DT',
		decimalSeparator: ',',
		decimalPlaces: 3,
		groupSeparator: ' ',
		isoCode: 'TND'
	},
	'fr-VU': {
		symbol: 'VT',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'VUV'
	},
	'fr-WF': {
		symbol: 'FCFP',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XPF'
	},
	'fr-YT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'fur-IT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'fy-NL': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ga': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XAF'
	},
	'ga-IE': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'gd': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'gd-GB': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'gl': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'gl-ES': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'gn': {
		symbol: '₲',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'GNF'
	},
	'gn-PY': {
		symbol: '₲',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'PYG'
	},
	'gsw-CH': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'gsw-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'gsw-LI': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'gu': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'gu-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'guz-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'gv-IM': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'ha-Latn-GH': {
		symbol: 'GH₵',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GHS'
	},
	'ha-Latn-NE': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'ha-Latn-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'haw-US': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'he-IL': {
		symbol: '₪',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ILS'
	},
	'hi-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'hr': {
		symbol: 'kn',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'HRK'
	},
	'hr-BA': {
		symbol: 'KM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BAM'
	},
	'hr-HR': {
		symbol: 'kn',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'HRK'
	},
	'hsb-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'hu': {
		symbol: 'Ft',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'HUF'
	},
	'hu-HU': {
		symbol: 'Ft',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'HUF'
	},
	'hy-AM': {
		symbol: '֏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AMD'
	},
	'ia-001': {
		symbol: 'XDR',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'XDR'
	},
	'ibb-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'id': {
		symbol: 'Rp',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'IDR'
	},
	'id-ID': {
		symbol: 'Rp',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'IDR'
	},
	'ig-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'ii-CN': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CNY'
	},
	'is': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'ISK'
	},
	'is-IS': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'ISK'
	},
	'it': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'it-CH': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'it-IT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'it-SM': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'it-VA': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'iu-Cans-CA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CAD'
	},
	'iu-Latn-CA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CAD'
	},
	'ja-JP': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'JPY'
	},
	'jgo-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'jmc-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'jv-Java-ID': {
		symbol: 'Rp',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'IDR'
	},
	'jv-Latn-ID': {
		symbol: 'Rp',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'IDR'
	},
	'ka-GE': {
		symbol: '₾',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'GEL'
	},
	'kab-DZ': {
		symbol: 'DA',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'DZD'
	},
	'kam-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'kde-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'kea-CV': {
		symbol: '​',
		decimalSeparator: '$',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CVE'
	},
	'khq-ML': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'ki': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AUD'
	},
	'ki-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'kk-KZ': {
		symbol: '₸',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'KZT'
	},
	'kkj-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'kl-GL': {
		symbol: 'kr.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'DKK'
	},
	'kln-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'km': {
		symbol: '៛',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KMF'
	},
	'km-KH': {
		symbol: '៛',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KHR'
	},
	'kn': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'kn-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ko-KP': {
		symbol: '₩',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'KPW'
	},
	'ko-KR': {
		symbol: '₩',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'KRW'
	},
	'kok-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'kr': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KRW'
	},
	'kr-Latn-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'ks-Arab-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ks-Deva-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ksb-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'ksf-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'ksh-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'ku-Arab-IQ': {
		symbol: 'د.ع.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'IQD'
	},
	'ku-Arab-IR': {
		symbol: 'IRR',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'IRR'
	},
	'kw': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KWD'
	},
	'kw-GB': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GBP'
	},
	'ky': {
		symbol: 'сом',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'KYD'
	},
	'ky-KG': {
		symbol: 'сом',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'KGS'
	},
	'la': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LAK'
	},
	'la-001': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'lag-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'lb': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'LBP'
	},
	'lb-LU': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'lg-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'lkt-US': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'ln-AO': {
		symbol: 'Kz',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'AOA'
	},
	'ln-CD': {
		symbol: 'FC',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CDF'
	},
	'ln-CF': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'ln-CG': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'lo-LA': {
		symbol: '₭',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'LAK'
	},
	'lrc-IQ': {
		symbol: 'د.ع.‏',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'IQD'
	},
	'lrc-IR': {
		symbol: 'IRR',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'IRR'
	},
	'lt': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'lt-LT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'lu': {
		symbol: 'FC',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'lu-CD': {
		symbol: 'FC',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CDF'
	},
	'luo-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'luy-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'lv': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'lv-LV': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'mas-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'mas-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'mer-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'mfe-MU': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MUR'
	},
	'mg': {
		symbol: 'Ar',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'MGA'
	},
	'mg-MG': {
		symbol: 'Ar',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'MGA'
	},
	'mgh-MZ': {
		symbol: 'MTn',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MZN'
	},
	'mgo-CM': {
		symbol: 'FCFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XAF'
	},
	'mi-NZ': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NZD'
	},
	'mk': {
		symbol: 'ден',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MKD'
	},
	'mk-MK': {
		symbol: 'ден',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MKD'
	},
	'ml': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'ml-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'mn': {
		symbol: '₮',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MNT'
	},
	'mn-MN': {
		symbol: '₮',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MNT'
	},
	'mn-Mong-CN': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CNY'
	},
	'mn-Mong-MN': {
		symbol: '₮',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MNT'
	},
	'mni-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'moh-CA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CAD'
	},
	'mr': {
		symbol: '₹',
		decimalSeparator: '`',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MRU'
	},
	'mr-IN': {
		symbol: '₹',
		decimalSeparator: '`',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ms': {
		symbol: 'RM',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XCD'
	},
	'ms-BN': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BND'
	},
	'ms-MY': {
		symbol: 'RM',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MYR'
	},
	'ms-SG': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SGD'
	},
	'mt': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'mt-MT': {
		symbol: '€',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'mua-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'my': {
		symbol: 'K',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'MYR'
	},
	'my-MM': {
		symbol: 'K',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'MMK'
	},
	'mzn-IR': {
		symbol: 'IRR',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'IRR'
	},
	'naq-NA': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NAD'
	},
	'nb-NO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'nb-SJ': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'nd-ZW': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'nds-DE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'nds-NL': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ne': {
		symbol: 'रु',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'ne-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ne-NP': {
		symbol: 'रु',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NPR'
	},
	'nl': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'nl-AW': {
		symbol: 'Afl.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'AWG'
	},
	'nl-BE': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'nl-BQ': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'USD'
	},
	'nl-CW': {
		symbol: 'NAf.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'ANG'
	},
	'nl-NL': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'nl-SR': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'SRD'
	},
	'nl-SX': {
		symbol: 'NAf.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'ANG'
	},
	'nmg-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'nn-NO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'nnh-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'no': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'nqo-GN': {
		symbol: 'ߖߕ.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GNF'
	},
	'nr': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'AUD'
	},
	'nr-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'nso-ZA': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'nus-SS': {
		symbol: '£',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SSP'
	},
	'nyn-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'oc-FR': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'om': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'OMR'
	},
	'om-ET': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ETB'
	},
	'om-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'or-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'os-GE': {
		symbol: '₾',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'GEL'
	},
	'os-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'pa': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PAB'
	},
	'pa-Arab-PK': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PKR'
	},
	'pa-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'pap-029': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'pl': {
		symbol: 'zł',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'PLN'
	},
	'pl-PL': {
		symbol: 'zł',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'PLN'
	},
	'prg-001': {
		symbol: 'XDR',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XDR'
	},
	'prs-AF': {
		symbol: '؋',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'AFN'
	},
	'ps': {
		symbol: '؋',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'ILS'
	},
	'ps-AF': {
		symbol: '؋',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'AFN'
	},
	'pt': {
		symbol: 'R$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'pt-AO': {
		symbol: 'Kz',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'AOA'
	},
	'pt-BR': {
		symbol: 'R$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BRL'
	},
	'pt-CH': {
		symbol: 'CHF',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CHF'
	},
	'pt-CV': {
		symbol: '​',
		decimalSeparator: '$',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'CVE'
	},
	'pt-GQ': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'pt-GW': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'pt-LU': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'pt-MO': {
		symbol: 'MOP$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MOP'
	},
	'pt-MZ': {
		symbol: 'MTn',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MZN'
	},
	'pt-PT': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'pt-ST': {
		symbol: 'Db',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'STN'
	},
	'pt-TL': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'USD'
	},
	'quc-Latn-GT': {
		symbol: 'Q',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'GTQ'
	},
	'quz-BO': {
		symbol: 'Bs.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BOB'
	},
	'quz-EC': {
		symbol: '$',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'USD'
	},
	'quz-PE': {
		symbol: 'S/',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PEN'
	},
	'rm-CH': {
		symbol: 'CHF',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'rn-BI': {
		symbol: 'FBu',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'BIF'
	},
	'ro': {
		symbol: 'lei',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'RON'
	},
	'ro-MD': {
		symbol: 'L',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MDL'
	},
	'ro-RO': {
		symbol: 'lei',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'RON'
	},
	'rof-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'ru': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'ru-BY': {
		symbol: 'Br',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BYN'
	},
	'ru-KG': {
		symbol: 'сом',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'KGS'
	},
	'ru-KZ': {
		symbol: '₸',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'KZT'
	},
	'ru-MD': {
		symbol: 'L',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MDL'
	},
	'ru-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'ru-UA': {
		symbol: '₴',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'UAH'
	},
	'rw': {
		symbol: 'RF',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'RWF'
	},
	'rw-RW': {
		symbol: 'RF',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'RWF'
	},
	'rwk-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'sa': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SAR'
	},
	'sa-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'sah-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'saq-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'sbp-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'sd': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SDG'
	},
	'sd-Arab-PK': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PKR'
	},
	'sd-Deva-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'se': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SEK'
	},
	'se-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'se-NO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'se-SE': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'SEK'
	},
	'seh-MZ': {
		symbol: 'MTn',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'MZN'
	},
	'ses-ML': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'sg': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'SGD'
	},
	'sg-CF': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'XAF'
	},
	'shi-Latn-MA': {
		symbol: 'MAD',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'shi-Tfng-MA': {
		symbol: 'MAD',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'si': {
		symbol: 'රු.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'EUR'
	},
	'si-LK': {
		symbol: 'රු.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LKR'
	},
	'sk': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sk-SK': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sl': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'SLL'
	},
	'sl-SI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'sma-NO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'sma-SE': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'SEK'
	},
	'smj-NO': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NOK'
	},
	'smj-SE': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'SEK'
	},
	'smn-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sms-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sn': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'sn-Latn-ZW': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'USD'
	},
	'so': {
		symbol: 'S',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'SOS'
	},
	'so-DJ': {
		symbol: 'Fdj',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'DJF'
	},
	'so-ET': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ETB'
	},
	'so-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'so-SO': {
		symbol: 'S',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'SOS'
	},
	'sq-AL': {
		symbol: 'Lekë',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'ALL'
	},
	'sq-MK': {
		symbol: 'den',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MKD'
	},
	'sq-XK': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sr': {
		symbol: 'RSD',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'SRD'
	},
	'sr-Cyrl-BA': {
		symbol: 'КМ',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BAM'
	},
	'sr-Cyrl-ME': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'sr-Cyrl-RS': {
		symbol: 'дин.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'RSD'
	},
	'sr-Cyrl-XK': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'sr-Latn-BA': {
		symbol: 'KM',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'BAM'
	},
	'sr-Latn-ME': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'sr-Latn-RS': {
		symbol: 'RSD',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'RSD'
	},
	'sr-Latn-XK': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'ss': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SSP'
	},
	'ss-SZ': {
		symbol: 'E',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SZL'
	},
	'ss-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'ssy-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'st': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'STN'
	},
	'st-LS': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'st-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'sv': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'USD'
	},
	'sv-AX': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sv-FI': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'EUR'
	},
	'sv-SE': {
		symbol: 'kr',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'SEK'
	},
	'sw-CD': {
		symbol: 'FC',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'CDF'
	},
	'sw-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'sw-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'sw-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'syr-SY': {
		symbol: 'ܠ.ܣ.‏',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SYP'
	},
	'ta-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ta-LK': {
		symbol: 'Rs.',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LKR'
	},
	'ta-MY': {
		symbol: 'RM',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MYR'
	},
	'ta-SG': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SGD'
	},
	'te-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'teo-KE': {
		symbol: 'Ksh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'KES'
	},
	'teo-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'tg': {
		symbol: 'смн',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'tg-Cyrl-TJ': {
		symbol: 'смн',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'TJS'
	},
	'th': {
		symbol: '฿',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'THB'
	},
	'th-TH': {
		symbol: '฿',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'THB'
	},
	'ti-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'ti-ET': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ETB'
	},
	'tig-ER': {
		symbol: 'Nfk',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ERN'
	},
	'tk': {
		symbol: 'm.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'NZD'
	},
	'tk-TM': {
		symbol: 'm.',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'TMT'
	},
	'tn': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'TND'
	},
	'tn-BW': {
		symbol: 'P',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'BWP'
	},
	'tn-ZA': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'to': {
		symbol: 'T$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TOP'
	},
	'to-TO': {
		symbol: 'T$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TOP'
	},
	'tr': {
		symbol: '₺',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'TRY'
	},
	'tr-CY': {
		symbol: '€',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'EUR'
	},
	'tr-TR': {
		symbol: '₺',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'TRY'
	},
	'ts-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'tt': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'TTD'
	},
	'tt-RU': {
		symbol: '₽',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'RUB'
	},
	'twq-NE': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'tzm-Arab-MA': {
		symbol: 'MAD',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'tzm-Latn-DZ': {
		symbol: 'DA',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'DZD'
	},
	'tzm-Latn-MA': {
		symbol: 'MAD',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'tzm-Tfng-MA': {
		symbol: 'ⴷⵔ',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'ug': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'ug-CN': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CNY'
	},
	'uk-UA': {
		symbol: '₴',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'UAH'
	},
	'ur-IN': {
		symbol: '₹',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'INR'
	},
	'ur-PK': {
		symbol: 'Rs',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'PKR'
	},
	'uz': {
		symbol: 'soʻm',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'UZS'
	},
	'uz-Arab-AF': {
		symbol: '؋',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: '.',
		isoCode: 'AFN'
	},
	'uz-Cyrl-UZ': {
		symbol: 'сўм',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'UZS'
	},
	'uz-Latn-UZ': {
		symbol: 'soʻm',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'UZS'
	},
	'vai-Latn-LR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LRD'
	},
	'vai-Vaii-LR': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'LRD'
	},
	've': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'VES'
	},
	've-ZA': {
		symbol: 'R',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'vi': {
		symbol: '₫',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'USD'
	},
	'vi-VN': {
		symbol: '₫',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '.',
		isoCode: 'VND'
	},
	'vo-001': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'vun-TZ': {
		symbol: 'TSh',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TZS'
	},
	'wae-CH': {
		symbol: 'CHF',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'CHF'
	},
	'wal-ET': {
		symbol: 'Br',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: '’',
		isoCode: 'ETB'
	},
	'wo-SN': {
		symbol: 'CFA',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'XOF'
	},
	'xh-ZA': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'ZAR'
	},
	'xog-UG': {
		symbol: 'USh',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'UGX'
	},
	'yav-CM': {
		symbol: 'FCFA',
		decimalSeparator: ',',
		decimalPlaces: 0,
		groupSeparator: ' ',
		isoCode: 'XAF'
	},
	'yi-001': {
		symbol: 'XDR',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'XDR'
	},
	'yo-BJ': {
		symbol: 'CFA',
		decimalSeparator: '.',
		decimalPlaces: 0,
		groupSeparator: ',',
		isoCode: 'XOF'
	},
	'yo-NG': {
		symbol: '₦',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'NGN'
	},
	'zgh-Tfng-MA': {
		symbol: 'MAD',
		decimalSeparator: ',',
		decimalPlaces: 2,
		groupSeparator: ' ',
		isoCode: 'MAD'
	},
	'zh-CN': {
		symbol: '¥',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'CNY'
	},
	'zh-Hans-HK': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'HKD'
	},
	'zh-Hans-MO': {
		symbol: 'MOP$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MOP'
	},
	'zh-HK': {
		symbol: 'HK$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'HKD'
	},
	'zh-MO': {
		symbol: 'MOP',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'MOP'
	},
	'zh-SG': {
		symbol: '$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'SGD'
	},
	'zh-TW': {
		symbol: 'NT$',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'TWD'
	},
	'zu-ZA': {
		symbol: 'R',
		decimalSeparator: '.',
		decimalPlaces: 2,
		groupSeparator: ',',
		isoCode: 'ZAR'
	}
};

const defaultCurrency = currencies['es-ES'];

// La regla para buscar un idioma es:
// - Si lo tengo definido en currencies, lo uso.
// - Si no lo tengo, trato de buscar sólo por idioma y coger ese
// - Si no hay y tengo alguna configuración regional con ese idioma, la cojo
// - Si tampoco la hay, cojo defaultCurrency

function getCurrency(navigatorLanguage: string) {

	// Si tengo idioma + región, lo devuelvo
	if (currencies[navigatorLanguage])
		return currencies[navigatorLanguage];

	// Si tengo el idioma, lo devuelvo
	const lang = navigatorLanguage.split('-')[0];
	if (currencies[lang])
		return currencies[lang];

	// Si tengo alguna configuración que coincide en idioma, me conformo,
	// y si no hay nada, me quedo con el valor por defecto
	const currencyKeys = Object.keys(currencies);
	const similarLanguage = currencyKeys.find(x => x.startsWith(lang));
	return similarLanguage ? currencies[similarLanguage] : defaultCurrency;
}

const currency = typeof navigator !== 'undefined' ? getCurrency(navigator.language) : defaultCurrency;

export const DECIMAL_PLACES = currency.decimalPlaces;
export const SYMBOL = currency.symbol;
export const ISOCODE = currency.isoCode;
export const DECIMAL_SEPARATOR = currency.decimalSeparator;
export const GROUP_SEPARATOR = currency.groupSeparator;


